import { useEffect, useState } from 'react'
import { XIcon } from '@heroicons/react/outline'
import Dropbox from '../Uploader/Dropbox'

const PreAuthRequestLookup = ({
  click,
  isShown,
  closeModal,
  successfulSubmission,
  failedSubmission,
}) => {
  const [uploadStatus, setUploadStatus] = useState('selectFiles')
  const [fileList, setFileList] = useState([])

  useEffect(() => {
    return () => {
      setUploadStatus('selectFiles')
      setFileList([])
    }
  }, [])

  return (
    <>
      <div
        style={{ zIndex: 999 }}
        className={`
      ${isShown ? '' : 'hidden'}
      fixed
      z-10
      w-full
      h-full
      bg-white-light
      bg-opacity-30
     inset-0
       text-center
    `}
      >
        <div
          className="relative w-[100%] h-[100%] md:w-[900px] md:h-[560px]"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'white',
            boxShadow: '0px 0px 70px 0px rgba(0,0,0,0.2)',
            zIndex: 9999,
          }}
        >
          {(uploadStatus === 'success' || uploadStatus === 'error') && (
            <StatusOverlay
              status={uploadStatus}
              fileList={fileList}
              closeModal={closeModal}
            />
          )}
          <div className="relative flex flex-col items-center h-full">
            <div className="mt-5" style={{ marginBottom: '5%' }}>
              <span className="text-2xl md:text-4xl">Upload your files</span>
              <XIcon
                onClick={closeModal}
                className="absolute w-10 h-10 cursor-pointer right-5 top-5 text-darkBlue"
                aria-hidden="true"
              />
            </div>
            <div className="flex flex-col h-full max-w-[550px] w-full">
              <Dropbox
                uploadStatus={uploadStatus}
                setUploadStatus={setUploadStatus}
                setFileList={setFileList}
              />
              {uploadStatus === 'selectFiles' && (
                <div className="bg-[#dbe9fd] mt-2 p-4 border-[#006BFF] border-2 text-left">
                  <p>
                    Attach your Prior authorization request form with supporting
                    clinical documentation here. You can submit documents in{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      txt, doc, pdf, jpg and png{' '}
                    </span>{' '}
                    file formats. Please note that the maximum file size is{' '}
                    <span style={{ fontWeight: 600 }}>30mb</span>.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const StatusOverlay = ({ status, fileList, closeModal }) => {
  return (
    <div
      style={{ zIndex: 1000 }}
      className="absolute inset-0 flex flex-col items-center justify-center flex-1 text-center bg-opacity-90 bg-white-light p-9 backdrop-blur-sm"
    >
      {status === 'success' ? (
        <>
          <span className="text-3xl">Successfully uploaded</span>
          <div className="flex flex-col items-center mt-4 p-9">
            <span className="text-xl">
              Here's a summary of the uploaded files
            </span>
            <div className="flex flex-col items-center w-full p-4 mt-4 overflow-hidden overflow-y-auto max-h-40">
              {fileList.map(file => (
                <span className="p-2 mb-2 rounded-md bg-[#dbf4db] drop-shadow-md border-[#5a8e5a] border-1">
                  {file}
                </span>
              ))}
            </div>
          </div>
        </>
      ) : (
        <>
          <span className="text-3xl">Failed to upload</span>
          <p className="text-xl text-center p-14">
            Unfortunately something went wrong uploading your files. Please
            contact customer service for further assistance
          </p>
        </>
      )}
      <button
        type="button"
        className={`w-[100px] p-2 px-4 mt-2 transition-all duration-200 border shadow-sm bg-[#007bff] border-blue hover:bg-[#1985fa] text-white-light disabled:bg-lightGrey disabled:text-black-default disabled:cursor-not-allowed`}
        onClick={closeModal}
      >
        Close
      </button>
    </div>
  )
}

export default PreAuthRequestLookup
